import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.min.css'

import favicon from '../../../assets/favicon.png'
import SiteConfig from '../../../../data/SiteConfig'
import Footer from '../Footer'
import './index.global.scss'

class Layout extends Component {
  render() {
    const { children } = this.props
    return (
      <div>
        <Helmet
          script={{
            type: 'application/ld+json',
            innerHTML: `{
            "@context": "http://schema.org",
            "@type": "NewsArticle"
        }`
          }}
        />
        <Helmet
          title="ProYuga"
          meta={[
            {
              name: 'description',
              content:
                'Developing transformative products in Virtual, Augmented and Mixed reality. We develop our own products, help others to develop their own products and offer development services to organizations. Our first product is iB Cricket, a new format of cricket, a vSport(eSport in Virtual Reality)'
            },
            { name: 'keywords', content: 'ProYuga, Tech' }
          ]}
        />
        <Helmet>
          <meta property="og:url" content="https://proyuga.tech" />
          <meta property="og:site_name" content="proyuga.tech" />
          <meta property="og:title" content="ProYuga" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            content="https://proyuga.tech/assets/images/SocialLinks/icFbLink.png"
          />
          <meta
            property="og:description"
            content="Developing transformative products in Virtual, Augmented and Mixed reality. We develop our own products, help others to develop their own products and offer development services to organizations. Our first product is iB Cricket, a new format of cricket, a vSport(eSport in Virtual Reality)"
          />
          <meta property="twitter:card" content="summary" />
          <meta property="twitter:site" content="https://proyuga.tech/" />
          <meta property="twitter:title" content="ProYuga" />
          <meta
            property="twitter:description"
            content="Developing transformative products in Virtual, Augmented and Mixed reality. We develop our own products, help others to develop their own products and offer development services to organizations. Our first product is iB Cricket, a new format of cricket, a vSport(eSport in Virtual Reality)"
          />
          <meta
            property="twitter:image"
            content="https://proyuga.tech/assets/images/SocialLinks/icFbLink.png"
          />
          <link rel="shortcut icon" type="image/png" href={favicon} />
        </Helmet>
        <div className="childrenContainer">{children}</div>
        <Footer />
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func
}

export default Layout
